export enum CommissionCalcType {
	CALCULATED = 1,
	MINIMUM = 2,
	MAXIMUM = 3
}
